//import { useParams } from "react-router-dom";
import React, { useState, useEffect } from 'react'
import { API, Auth } from 'aws-amplify';
import { Heading } from '@aws-amplify/ui-react';
import "@aws-amplify/ui-react/styles.css";
import "react-datepicker/dist/react-datepicker.css";
import Loadingmini from '../components/loadingmini';
import { FaWindowClose } from 'react-icons/fa';
import { Button, View, Divider, Flex, Text } from '@aws-amplify/ui-react';
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import { multiRowSelection } from '../agGridRowSelection';
import Messagecreate from "../components/messagecreate";
//import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import { themeQuartz } from 'ag-grid-community'; //import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import { useLocation } from "react-router-dom";

export default function ChatMessages({userJwt, refreshJwt}) {
  //let params = useParams();
  const [is_loading, updateIsLoading] = React.useState(false);
  const location = useLocation();
  const [selected_fleet, updateSelectedFleet] = React.useState([]);
  const [res, updateRes] = useState({status:"loading...",rows:[]})
  const [count, setCount] = useState(0);
  const [displayAdministrativeFunctions, updateDisplayAdministrativeFunctions] = React.useState(false);
  const [displaySuperAdministrativeFunctions, updateDisplaySuperAdministrativeFunctions] = React.useState(false);
  const [isInsurerUsertype, updateIsInsurerUsertype] = React.useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const fleetsParam = params.get("fleets");
    if (fleetsParam) {
        updateSelectedFleet(fleetsParam.split(","));
    } else {
        updateSelectedFleet([]);
    }
  }, [location.search]);

  const columns = [
    {
        headerName: 'Sent Timestamp',
        field: 'sql_timestamp',
        filter: true,
        flex:2
    },
    {
        headerName: 'Sender',
        field: 'sender_name',
        filter: true,
        flex:2
    },
    {
        headerName: 'Message',
        field: 'message',
        filter: true,
        width: 350,
        wrapText: true,
        autoHeight: true,
        cellStyle: { whiteSpace: 'normal', lineHeight: '1.5'}
    },
    {
        headerName: 'Service Level',
        field: 'service_level',
        filter: true,
        flex:2
    },
    {
        headerName: ' ',
        field: 'id',
        filter: true,
        flex:1,
        cellRenderer: params => {
            let val = params.value
            return( <FaWindowClose onClick={() => setMessageRead(val)} style={{cursor: 'pointer', height:22, width:22}}/>)
        }
    }
];

  async function fetchPageData() {
    updateIsLoading(true);
    let session = await Auth.currentSession()      
    var accessToken = session.getAccessToken()
    if(accessToken.payload["cognito:groups"])
    {
        if(accessToken.payload["cognito:groups"][0]==='admin')
        {
            updateDisplayAdministrativeFunctions(true)
            updateDisplaySuperAdministrativeFunctions(true)
        } else {
            if(accessToken.payload["cognito:groups"][0]==='support'||accessToken.payload["cognito:groups"][0]==='fleet')
            {
                updateDisplayAdministrativeFunctions(true)
            } else {
                if(accessToken.payload["cognito:groups"][0]==='insurer')
                {
                    updateIsInsurerUsertype(true)
                }
            }
        }
    }
    try {
        const myInit = {queryStringParameters:{ 
            "back_end": process.env.REACT_APP_BACKEND,
            "jwt":userJwt,
            "api_endpoint": "api3:staff:messages"
        }};
        const res = await API.get('adminWebTools','/ago',myInit)
        updateRes(res)
        if('detail' in res)
        {
            if(res['detail'].includes("token"))
            {
                refreshJwt()
            }
        }
    }
    catch (e) {
        //const res = {status:"Error retrieving User information - email us at info@joinago.com: "+toString(e)}
        //updateRes(res) 
        if(e.response.status === 401)
          {
              refreshJwt()
          }
    }
    updateIsLoading(false)
  }

  useEffect(() => {
    fetchPageData();
  },[count, userJwt])





  async function setMessageRead(chatId)
  {
    updateIsLoading(true)
    try {
        //console.log('chat_id:'+chatId)
        const myInit = {queryStringParameters:{ 
            "back_end": process.env.REACT_APP_BACKEND,
            "jwt":userJwt,
            "api_endpoint": "api3:staff:messages",
            "chat_id":chatId
        }};
        const res = await API.get('adminWebTools','/ago',myInit)
        //console.log(JSON.stringify(res))
        updateRes(res)
        updateIsLoading(false)
        //fetchPageData()
    }
    catch (e) {
        //const res = {status:"Error retrieving User information - email us at info@joinago.com: "+toString(e)}
        //updateRes(res)
      updateIsLoading(false)
    }
  }

  return (
    <Flex
      direction="column"
    >
      <View style={{padding:"1rem"}}>
        <Divider />
        {
            is_loading ? <Loadingmini /> : 
            <Flex 
                direction='column'
            >
                <Heading level={2}>Messages</Heading>
                <Text style={{width:'100%'}}>These are unread messages for you and your fleet.</Text>
                <Flex direction="row" wrap="wrap" justifyContent="flex-start" gap="1rem">
                    <View>
                        <Button onClick={() => setCount(count + 1)}>
                            PRESS TO GET LATEST UPDATES
                        </Button>
                    </View>
                </Flex>
                {
                    displayAdministrativeFunctions === false ? undefined :
                    <Messagecreate fleetCode={selected_fleet[0]} refreshParent={fetchPageData}/>
                }
                <Divider />
                <Text><i>Dismissing a fleet-wide message dismisses it for the entire fleet.</i></Text>
                <View style={{width:"100%"}}>
                    <View 
                        theme={themeQuartz} //className="ag-theme-quartz" // applying the grid theme
                        style={{ height: 500 }} // the grid will fill the size of the parent container
                    >
                            <AgGridReact
                                rowData={res.rows}
                                columnDefs={columns}
                                rowSelection={multiRowSelection}
                                paginationPageSize={500}
                                paginationPageSizeSelector={[10, 25, 50]}
                                enableCellTextSelection={true}
                            />
                    </View>
                </View>
            </Flex>
        }
        <Divider />
      </View>
    </Flex>
  );
}